import { styled as a, modifier as p, css as l, variants as m } from "@lokalise/styled";
import { spacing as e, typography as h, value as o } from "../../utils/theme/index.js";
const t = 6, i = 24, r = 320, n = 840, s = 640, x = a.header`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	padding: ${e(t)};
`, u = a.h2`
	${h("heading.4")}
	color: ${o("color.text.default")};
	width: 100%;
	margin: 0;
`, g = a.div`
	${p(
  "$isOverflow",
  l`
			box-shadow:
				0 1px 0 0 ${o("color.border.light")},
				0 -1px 0 0 ${o("color.border.light")};
		`
)}

	padding: ${e(0, t, t, t)};
`, c = a.footer`
	display: flex;
	justify-content: flex-end;
	gap: ${e(2)};
	padding: ${e(t, t, t, t)};
`, w = a.div`
	/*
	* Section should be scrollable only when Footer is present. In Expert (lokalise-main) Modal grows as high
	* as it needs and when it gets higher than viewport body becomes scrollable. In order to not break this behavior
	* and have backwards compatability we can detect if the Footer and Main is present and only then make Main
	* scrollable. Hawing modal scrollable without footer probably would be wierd.
	*/

	// ":has" is not supported in Firefox - fall back to default Modal scroll.
	&:has(${c}) {
		// Handle an edge case on small screens - if screen height is too small fall back to default Modal scroll.
		@media (min-height: 400px) {
			display: flex;
			flex-direction: column;

			max-height: calc(100vh - ${e(3)} * 2);

			@media (min-width: 768px) {
				max-height: calc(100vh - ${e(7)} * 2);
			}
		}
	}

	&:has(${c}) ${g} {
		@media (min-height: 400px) {
			overflow-y: auto;
			scrollbar-gutter: stable; // Adds padding in a width of a scrollbar even when the scrollbar is not present which fixes the issue with shifting content.
			padding: ${e(t)};

			/*
			* "scrollbar-gutter" are not supported on Safari. There the layout will shift to the right if scrollbar will
			* be present. It is possible to determine overflow by JS, but in case there is a shift to or from this
			* "overflow" state, content jumps for a split second. It happens because time passes between the appearance
			* of scrollbar and the time it takes to add/remove CSS and recalculate layout.
			*/
			@supports (scrollbar-gutter: stable) {
				// Subtract padding added by "scrollbar-gutter".
				padding-right: calc(${e(t)} - ${(d) => d.$scrollbarWidth}px);
			}
		}
	}
`, $ = a.div`
	display: flex;
	justify-content: flex-end;
	gap: ${e(2)};
	padding-top: ${e(6)};

	@media (min-width: 768px) {
		padding-top: ${e(7)};
	}
`, y = a.div`
	background: rgba(0, 0, 0, 0.5);
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	overflow: auto;
	z-index: ${o("zIndex.modal")};
`, v = a.dialog`
	background-color: ${o("color.background.surface.default")};
	border-radius: ${o("radius.modal")};
	border: none;
	box-sizing: border-box;
	${h("body.small.default")}
	color: ${o("color.text.default")};
	margin: revert; // ensure that browser can determine the correct margins to position the dialog
	margin-top: ${e(3)};
	padding: 0;
	overflow: ${({ $overflow: d }) => d};

	@media (min-width: 768px) {
		margin-top: ${e(7)};
	}

	width: 100%;

	${m(
  "$size",
  {
    small: l`
				max-width: calc(100% - ${i}px);
				@media (min-width: ${r + i}px) {
					max-width: ${r}px;
				}
			`,
    wide: l`
				max-width: calc(100% - ${i}px);
				@media (min-width: ${n + i}px) {
					max-width: ${n}px;
				}
			`,
    default: l`
				max-width: calc(100% - ${i}px);
				@media (min-width: ${s + i}px) {
					max-width: ${s}px;
				}
			`
  },
  "default"
)}
`;
export {
  $ as Actions,
  w as Content,
  y as DialogOverlay,
  c as Footer,
  x as Header,
  g as Main,
  v as StyledDialog,
  u as Title
};
//# sourceMappingURL=styles.js.map
